<template>
    <b-modal id="modal_form"
             ref="modal_form"
             :title="modal_titulo"
             :ok-title="modal_botao"
             close-title="Fechar"
             cancel-title="Cancelar"
             size="lg"
             :ok-disabled=form.errors.any()
             v-model="showModal"
             @ok="handleOk">

        <form @submit.stop.prevent="handleOk" @keydown="form.errors.clear($event.target.name)">
            <b-row no-gutters>
                <b-col class="p-0">
                    <label>Ordem</label>
                    <b-form-input type="text"
                                  placeholder="Ordem"
                                  v-model="form.ordem"
                                  name="ordem"
                                  >
                    </b-form-input>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('ordem')" v-if="form.errors.has('ordem')"></b-form-feedback>
                </b-col>
                <b-col class="p-0">
                    <label>Advalorem</label>
                    <currency-input
                        class="form-control"
                        v-model="form.perc_advalorem"
                        placeholder="Advalorem"
                        :auto-decimal-mode="true"
                        :currency="{ prefix: '%'}"
                        :distraction-free="getCurrency"/>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('perc_advalorem')" v-if="form.errors.has('perc_advalorem')"></b-form-feedback>
                </b-col>
                <b-col class="p-0">
                    <label>Principal ?</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.principal"
                        :options="optionsLivPrincipal"
                        name="principal"
                        plain
                        stacked
                        value-field="value"
                      ></b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col class="p-0">
                    <label>Tipo Trecho</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.tp_trecho"
                        :options="optionsLivTpTrecho"
                        name="tp_trecho"
                        plain
                        stacked
                        value-field="value"
                      ></b-form-radio-group>
                    </b-form-group>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('tp_trecho')" v-if="form.errors.has('tp_trecho')"></b-form-feedback>
                </b-col>
                <b-col class="p-0">
                    <label>Custo</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.tp_custo"
                        :options="optionsLivTpcusto"
                        name="tp_custo"
                        plain
                        stacked
                        value-field="value"
                      ></b-form-radio-group>
                    </b-form-group>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('tp_custo')" v-if="form.errors.has('tp_custo')"></b-form-feedback>
                </b-col>
                <b-col class="p-0">
                    <label>Tipo</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.tp_trecho_custo"
                        :options="optionsLivTpTrechoCusto"
                        name="tp_trecho_custo"
                        plain
                        stacked
                        value-field="value"
                      ></b-form-radio-group>
                    </b-form-group>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('tp_trecho_custo')" v-if="form.errors.has('tp_trecho_custo')"></b-form-feedback>
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col class="p-0">
                    <label>Modal</label>
                        <multiselect v-model="modalSelected"
                            :options="optionsModal"
                            track-by="value"
                            label="label"
                            :hide-selected="true"
                            placeholder="Selecione"
                            tag-placeholder="Selecionar"
                            select-label="Selecionar"
                            selected-label="Selecionado"
                            deselect-label="Remover"
                        ></multiselect>
                        <b-form-feedback class="text-danger" v-text="form.errors.get('bmodal_id')" v-if="form.errors.has('bmodal_id')"></b-form-feedback>
                </b-col>
                <b-col class="p-0">
                    <label>Município Início</label>
                    <multiselect v-model="municipioIniSelected"
                        :options="optionsMunicipio"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('municipio_id_ini')" v-if="form.errors.has('municipio_id_ini')"></b-form-feedback>
                </b-col>
                <b-col class="p-0">
                    <label>Município Fim</label>
                    <multiselect v-model="municipioFimSelected"
                        :options="optionsMunicipio"
                        track-by="value"
                        label="label"
                        :hide-selected="true"
                        placeholder="Selecione"
                        tag-placeholder="Selecionar"
                        select-label="Selecionar"
                        selected-label="Selecionado"
                        deselect-label="Remover"
                    ></multiselect>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('municipio_id_fim')" v-if="form.errors.has('municipio_id_fim')"></b-form-feedback>
                </b-col>
            </b-row>
            <b-row no-gutters>
                <b-col class="p-0">
                    <label>Fornecedor</label>
                    <multiselect v-model="fornecedorSelected"
                    :options-limit="300"
                    :limit="2"
                    :limit-text="limitText"
                    :options="optionsFornecedor"
                    track-by="value"
                    label="label"
                    :hide-selected="true"
                    placeholder="Fornecedor ( Digite para pesquisar )"
                    tag-placeholder="Selecionar"
                    select-label="Selecionar"
                    selected-label="Selecionado"
                    deselect-label="Remover"
                    :searchable="true"
                    :loading="isLoadingFor"
                    @search-change="listaClientesFornecedor"
                    ></multiselect>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('pessoa_id_for')" v-if="form.errors.has('pessoa_id_for')"></b-form-feedback>
                </b-col>
                <b-col class="p-0">
                    <label>Status</label>
                    <b-form-group>
                      <b-form-radio-group
                        v-model="form.status"
                        :options="optionsLivStatus"
                        name="status"
                        plain
                        stacked
                        value-field="value"
                      ></b-form-radio-group>
                    </b-form-group>
                    <b-form-feedback class="text-danger" v-text="form.errors.get('status')" v-if="form.errors.has('status')"></b-form-feedback>
                </b-col>
            </b-row>
        </form>
        <div slot="modal-footer" class="w-100">
            <div class="float-left"><spinner v-if="loading" message="Processando..."></spinner></div>
            <div class="float-right">
                 <b-btn @click="showModal=false" variant="secondary">
                   Fechar
                 </b-btn>
                 <b-btn @click="handleOk($event)" variant="secondary" :disabled="isDisabled">
                   Enviar
                 </b-btn>
            </div>
        </div>
    </b-modal>
</template>
<script>
import { formatCNPJFromParts } from "../utils";


export default {
components: {
},
props: {
    metodo: {type: Function},
    tabela: '',
    rota: ''
},
data () {
    return {
      dataExport: [],
      modal_titulo: '',
      modal_botao: '',
      modal_acao: '',
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      isLoadingFor: false,
      isFullscreen: false,
      modalSelected: [],
      municipioIniSelected: [],
      municipioFimSelected: [],
      fornecedorSelected: [],
      optionsLivStatus: [],
      optionsLivTpcusto: [],
      optionsLivPrincipal: [],
      optionsLivTpTrecho: [],
      optionsModal: [],
      optionsMunicipio: [],
      optionsFornecedor: [],
      optionsLivTpTrechoCusto: [],
      form: new Form({
                       peduncatr_id: '',
                       pedunicar_id: '',
                       ordem: '',
                       status: '',
                       tp_custo: '',
                       tp_trecho: '',
                       principal: 2,
                       perc_advalorem: 0,
                       tp_trecho_custo: '',
                       bmodal_id: '',
                       municipio_id_ini: '',
                       municipio_id_fim: '',
                       pessoa_id_for: ''
                   }),
     helpForm: new Form({statusRecord: [], params: [], search: ''}),
    fields: [],
  css: {
      loadingClass: 'loading',
      ascendingIcon: 'glyphicon glyphicon-chevron-up',
      descendingIcon: 'glyphicon glyphicon-chevron-down',
      handleIcon: 'glyphicon glyphicon-menu-hamburger',
  },
  moreParams: {}
   }
},
watch: {
    fornecedorSelected(obj) {
        this.form.pessoa_id_for = obj.value;
    },
    municipioIniSelected(obj) {
        this.form.municipio_id_ini = obj.value;
    },
    municipioFimSelected(obj) {
        this.form.municipio_id_fim = obj.value;
    },
    modalSelected(obj) {
        this.form.bmodal_id = obj.value;
    },
},
mounted() {
    this.getLivGeral();
  },
methods: {
    handleOk(e)
    {
        e.preventDefault();
        if(this.modal_acao=="i")
        {
           this.onStore();
        }
        else
        {
            this.onUpdate(this.form.peduncatr_id);
        }
    },
    onCreate(data)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Vincular Trecho";
      this.modal_botao = "Vincular Trecho";
      this.modal_acao = "i";
      this.modalSelected = [];
      this.municipioIniSelected = [];
      this.municipioFimSelected = [];
      this.fornecedorSelected = [];
      this.form.reset();
      this.form.pedunicar_id = data.pedunicar_id;
      this.$refs.modal_form.show();
    },
    onEdit (data, index, id)
    {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar Trecho";
      this.modal_botao = "Alterar Trecho";
      this.modal_acao = "u";
      this.modalSelected = [];
      this.municipioIniSelected = [];
      this.municipioFimSelected = [];
      this.fornecedorSelected = [];
      this.form.reset();
      this.form.ordem = data.ordem;
      this.form.perc_advalorem = data.perc_advalorem;
      this.form.status = data.status.valor
      this.form.principal = data.principal.valor
      this.form.tp_custo = data.tp_custo.valor
      this.form.tp_trecho = data.tp_trecho.valor
      this.form.tp_trecho_custo = data.tp_trecho_custo.valor
      this.modalSelected = { label: data.b_modal.descr, value: data.b_modal.bmodal_id };
      this.municipioIniSelected = { label: data.municipio_inicio.nome, value: data.municipio_inicio.municipio_id };
      this.municipioFimSelected = { label: data.municipio_fim.nome, value: data.municipio_fim.municipio_id };
      if(data.fornecedor.pessoa_juridica!==null)
      {
          this.fornecedorSelected = { label: data.fornecedor.cd+" - "+data.fornecedor.pessoa_juridica.razao_social+" - "+this.onFormataCnpj(data.fornecedor.pessoa_juridica.cnpj_base,data.fornecedor.pessoa_juridica.cnpj_filial,data.fornecedor.pessoa_juridica.cnpj_digito)+" - "+data.fornecedor.pessoa_juridica.inscricao_estadual, value: data.fornecedor.pessoa_juridica.pessoa_id };
      }
      if(data.fornecedor.pessoa_fisica!==null)
      {
          this.fornecedorSelected = { label: data.fornecedor.cd+" - "+data.fornecedor.pessoa_fisica.nome+" - "+data.fornecedor.pessoa_fisica.cpf, value: data.fornecedor.pessoa_fisica.pessoa_id };
      }
      if(data.fornecedor.pessoa_exterior!==null)
      {
          this.fornecedorSelected = { label: data.fornecedor.cd+" - "+data.fornecedor.pessoa_exterior.nome+" - "+data.fornecedor.pessoa_exterior.cuit, value: data.fornecedor.pessoa_exterior.pessoa_id };
      }
      this.form.pedunicar_id = data.pedunicar_id;
      this.form.peduncatr_id = data.peduncatr_id;
      this.$refs.modal_form.show();
    },
    onStore()
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.put('/api/gerenciamentotransporte/trecho/store').then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
            else
            {
                Event.$emit('reloadVuetable');
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onUpdate(id)
    {
        this.loading = true;
        this.isDisabled = true;
        this.form.patch('/api/gerenciamentotransporte/trecho/update/'+id).then(response =>
        {
            new ReturnApi(response, this)
            if(this.metodo!=null)
            {
               this.metodo();
            }
            else
            {
                Event.$emit('reloadVuetable');
            }
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    onCalcular(data)
    {
      this.loading = true;
      this.isDisabled = true;
      this.form.patch('/api/gerenciamentotransporte/trecho/calculo/'+data.peduncatr_id).then(response =>
      {
        new ReturnApi(response, this)
        if(this.metodo!=null)
        {
          this.metodo();
        }
        else
        {
          Event.$emit('reloadVuetable');
        }
      })
      .catch(errors =>
      {
        new ReturnApi(errors, this)
      });
    },
    getLivGeral()
    {
        this.helpForm.get('/api/gerenciamentotransporte/jsonlistgeraltrecho').then(response =>
        {
            new ReturnApi(response, this, true, false, false);
            response.status.forEach((obj)=>
            {
                this.optionsLivStatus.push({ text: obj.descr, value: obj.valor })
            })
            response.tp_custo.forEach((obj)=>
            {
                this.optionsLivTpcusto.push({ text: obj.descr, value: obj.valor })
            })
            response.tp_trecho.forEach((obj)=>
            {
                this.optionsLivTpTrecho.push({ text: obj.descr, value: obj.valor })
            })
            response.principal.forEach((obj)=>
            {
                this.optionsLivPrincipal.push({ text: obj.descr, value: obj.valor })
            })
            response.tp_trecho_custo.forEach((obj)=>
            {
                this.optionsLivTpTrechoCusto.push({ text: obj.descr, value: obj.valor })
            })
            response.municipio.forEach((obj)=>
            {
                this.optionsMunicipio.push({ label: obj.nome, value: obj.municipio_id })
            })
            response.modal.forEach((obj)=>
            {
                this.optionsModal.push({ label: obj.descr, value: obj.bmodal_id })
            })
        })
        .catch(errors =>
        {
            new ReturnApi(errors, this)
        });
    },
    listaClientesFornecedor(search) {
        if(search.length>=3)
        {
            this.isLoadingFor = true;
            this.helpForm.search = search;
            this.helpForm.post('/api/pessoa/jsonlist/fornecedor').then(response =>
            {
                this.optionsFornecedor = [];
                new ReturnApi(response, this, true, false, false);
                response.items.forEach((obj)=>
                {
                    this.optionsFornecedor.push({ label: obj.pessoa.cd+" - "+obj.razao_social+" - "+this.onFormataCnpj(obj.cnpj_base,obj.cnpj_filial,obj.cnpj_digito)+" - "+obj.inscricao_estadual, value: obj.pessoa_id })
                })
                response.itemsF.forEach((obj)=>
                {
                    this.optionsFornecedor.push({ label: obj.pessoa.cd+" - "+obj.nome+" - "+obj.cpf, value: obj.pessoa_id })
                })
                response.itemsE.forEach((obj)=>
                {
                    this.optionsFornecedor.push({ label: obj.pessoa.cd+" - "+obj.nome+" - "+obj.cuit, value: obj.pessoa_id })
                })
                this.isLoadingFor = false;
            })
            .catch(errors =>
            {
                new ReturnApi(errors, this)
              });
          }
      },
      limitText (count) {
        return ' e ${count} outros clientes'
      },
            onFormataCnpj(cnpj_base, cnpj_filial, cnpj_digito) {
        return formatCNPJFromParts(cnpj_base, cnpj_filial, cnpj_digito);
      },
    onError(response) {
        new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
        return this.getPermissionFw(checkPermission);
    },
},
computed: {
    vuetableFilterRow: {
      get () {
        return this.$store.state.vuetable.filterRow;
      },
    },
    getCurrency: {
        get() {
            return this.$store.getters.currency;
        }
    },
    isLoaded: {
        get() {
            return this.$store.getters.isloaded;
        }
    }
}
}
</script>